import { render, staticRenderFns } from "./Product.vue?vue&type=template&id=053d0bc4&scoped=true"
import script from "./Product.vue?vue&type=script&lang=js"
export * from "./Product.vue?vue&type=script&lang=js"
import style0 from "./Product.vue?vue&type=style&index=0&id=053d0bc4&prod&lang=scss&scoped=true"
import style1 from "./Product.vue?vue&type=style&index=1&id=053d0bc4&prod&lang=scss&scoped=true"
import style2 from "./Product.vue?vue&type=style&index=2&id=053d0bc4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053d0bc4",
  null
  
)

export default component.exports